import { ScoreValue } from "src/api/client-api/olapScores/olapScoresSchema";
import { DimensionPath, Dimensions, Dimension } from "src/context/OlapScores/useDimensions";

export type FlattenedDimensionValue = {
    score: ScoreValue;
    label: string;
};

export class OlapParamsService {
    public static getInitialDimensions = (dimensions: Dimensions, length: number = 3): Dimensions => {
        return OlapParamsService.getRemainingDimensions(null, dimensions, length);
    };

    public static getRemainingDimensions = (
        firstDimension: Dimension | null,
        dimensions: Dimensions = [],
        length: number = 3,
    ): Dimensions => {
        const [firstDimensionKey, firstDimensionValues] = firstDimension ?? [];

        return dimensions.flatMap((dimensionPath: DimensionPath) => {
            if (firstDimension === null) return [dimensionPath.slice(0, length)];

            const dimensionStartIndex =
                dimensionPath.findIndex((dimension) => {
                    const [dimensionKey, dimensionValues] = dimension;

                    if (firstDimensionValues === undefined) return dimensionKey === firstDimensionKey;

                    return (
                        dimensionKey === firstDimensionKey &&
                        (dimensionValues === undefined || dimensionValues.includes(firstDimensionValues[0]))
                    );
                }) + 1;

            if (dimensionStartIndex === 0) return [];

            return [dimensionPath.slice(dimensionStartIndex, dimensionStartIndex + length)];
        });
    };

    public static getDimensionsWithPrependedDimension = (
        dimension: Dimension,
        remainingDimensions: Dimensions = [],
    ): Dimensions => {
        return remainingDimensions.map((dimensions) => {
            return [dimension, ...dimensions];
        });
    };
}
